import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { FxExposure, FxRevaluationRun, RevaluationPreview } from '../interfaces/fx.interface';

export const FxRevaluationService = {
    preview: async (institutionId: string, asOf: string): Promise<RevaluationPreview> =>
        (await axios.get(ENDPOINTS.FX_REVALUATION.PREVIEW(institutionId), { params: { asOf } })).data,
    exposure: async (institutionId: string, asOf: string): Promise<FxExposure> =>
        (await axios.get(ENDPOINTS.FX_REVALUATION.EXPOSURE(institutionId), { params: { asOf } })).data,
    runs: async (institutionId: string): Promise<FxRevaluationRun[]> =>
        (await axios.get(ENDPOINTS.FX_REVALUATION.RUNS(institutionId))).data,
    run: async (institutionId: string, runId: string): Promise<FxRevaluationRun> =>
        (await axios.get(ENDPOINTS.FX_REVALUATION.RUN(institutionId, runId))).data,
    execute: async (institutionId: string, asOfDate: string): Promise<FxRevaluationRun> =>
        (await axios.post(ENDPOINTS.FX_REVALUATION.RUNS(institutionId), { asOfDate })).data,
    /** acknowledgeBankLoss must be true when the run detail listed undoLossWarnings (the server answers 400 otherwise). */
    undo: async (institutionId: string, runId: string, acknowledgeBankLoss = false): Promise<FxRevaluationRun> =>
        (await axios.post(ENDPOINTS.FX_REVALUATION.UNDO(institutionId, runId), null, { params: { acknowledgeBankLoss } })).data,
};
